import { z } from 'zod';
import { send } from '@/core/api/request';
import { ApiError } from '@/core/api/errors';

const ok = z.unknown();

export const authApi = {
  sendCode: (phone: string) => send('post', 'passenger/send_verification_code_by_sms_api/', ok, { phone_number: phone }),

  verifyCode: async (phone: string, code: string): Promise<string> => {
    const res = await send(
      'post',
      'passenger/sms_code_verification_view/',
      z.object({ access_token: z.string().min(1) }),
      { phone_number: phone, verification_code: code },
    );
    return res.access_token;
  },

  /** The API answers 400 for an invalid/expired token; anything else is a real error. */
  verifyToken: async (token: string): Promise<boolean> => {
    try {
      await send('post', 'passenger/verify-access-token', ok, { token });
      return true;
    } catch (e) {
      if (e instanceof ApiError && (e.status === 400 || e.status === 401)) return false;
      throw e;
    }
  },
};
